var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"left-timer"},[_vm._v(_vm._s(_vm.timer))]),_c('div',{staticClass:"head-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"large",on:{"click":_vm.screen}},[_c('img',{attrs:{"src":require("../../assets/template/screen.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }